import { Action } from '@ngrx/store';
import {
    ActionOptionsArgs,
    SynchronisableAction
} from '../../../core/store/actions/base-actions';
import { Note } from './note.model';

export const ENTITY = 'note';
export const SUBMIT = '[Note] Submit';
export const REHYDRATE = '[Note] Rehydrate';
export const REMOVE = '[Note] Remove';

export class SubmitAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = SUBMIT;

    constructor(public payload: Note, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class RehydrateAction implements Action {
    readonly type = REHYDRATE;

    constructor(public payload: Array<Note>) {

    }
}

export class RemoveAction extends SynchronisableAction {
    readonly type = REMOVE;
    readonly entity = ENTITY;

    constructor(public payload: Note, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export type Actions
    = SubmitAction
    | RehydrateAction
    | RemoveAction;



// WEBPACK FOOTER //
// ./src/vas/business-objects/note/note.actions.ts